"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _definitions = require('../../definitions');
var _mergeClassName = require('../../../utils/mergeClassName'); var _mergeClassName2 = _interopRequireDefault(_mergeClassName);

const settingsSchema = null;

const component = {
  mixins: [_definitions.vueComponentMixin],
  methods: {
    handleClick() {
      this.editValue = this.container.stub.getDefaultValue();
    }
  },
  computed: {
    finalClassName() {
      const props = this.$props;
      const settings = props.uiSettings;
      return _mergeClassName2.default.call(void 0, props.ui.className, props.className);
    }
  }
};

exports. default = component;

/**
 * 对象里有些字段是 undefined，无法渲染输入框组件，因此要做个 override，用“添加配置”的按钮顶替上去
 */
 const fillDefaultValueModule = {
  id: "basicForm.__fillDefaultValue__",
  component
}; exports.fillDefaultValueModule = fillDefaultValueModule;

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "ds-basicForm-fillDefaultValue",
      style: _vm.props.ui.style,
      attrs: {
        id: _vm.props.inputId,
        disabled: _vm.props.readonly,
        className: _vm.finalClassName
      },
      on: { click: _vm.handleClick }
    },
    [
      _vm._v(
        "\n  未配置" + _vm._s(_vm.props.readonly ? "" : "，点击添加") + "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
